<template>
  <div class="page-tabs">
    <div>
      <ul v-if="showFlag === '1'">
        <li><span style="color:#A5A5A5;font-weight: 600;">汇总条件</span></li>
        <li
          v-for="(tab, index) in tabs"
          :key="index"
          :name="tab.value"
          :class="addClass(tab.value)?'blue':''"
          @click="handleClick(tab.value)"
        >
          <span>{{ tab.name }}</span>
        </li>
      </ul>
      <el-tabs v-if="showFlag === '0'" v-model="activeName" @tab-click="tabchange">
        <el-tab-pane v-for="(value, index) in statustabs" :key="index" :label="value.name" :name="value.value" />
      </el-tabs>
    </div>
    <btn :btn-config="mingxitabs" @input="showfn" />
  </div>
</template>

<script>
import btn from './btn'
// import BtnTabs from '@/components/common/button-tabs'
export default {
  components: {
    btn
    // BtnTabs
  },
  inject: {
    $page: {
      default: () => ({})
    }
  },
  props: {
    // eslint-disable-next-line
    $tabs: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mingxitabs: {
        default: '0', // 默认值
        btns: [{ value: '0', text: 'bill.table.cuttabs[0]' }, { value: '1', text: 'bill.table.cuttabs[1]' }]
      },
      statustabs: [
        { value: '', name: '全部' }, { value: 'N', name: '未确认' }, { value: 'Y', name: '已确认' }
      ],
      tabs: [{ value: 'goodsSumSign', name: '按料件汇总' }, { value: 'purchaseSumSign', name: '按订单汇总' }, { value: 'asnSumSign', name: '按发货单汇总' }],
      statusList: [],
      activeName: '',
      showFlag: '0'
    }
  },
  computed: {
    api() {
      return this.$tabs._api || (() => new Promise(resolve => resolve([])))
    },
    valueprop() {
      return this.$tabs._value
    },
    name() {
      return this.$tabs._name
    },
    count() {
      return this.$tabs._count
    },
    max() {
      return this.$tabs._max || 999
    },
    btnConfig() {
      return this.$tabs._btn
    }
  },
  created() {
    this.tabs.forEach(item => {
      console.log()
      this.$page[item.value] = null
    })
  },
  methods: {
    showfn(value) {
      this.$page.btn = value
      this.$emit('input')
      // this.fullscreenLoading = true
      // setTimeout(() => {
      //   this.fullscreenLoading = false
      // }, 2000)
      this.showFlag = value
    },
    changeBtn(value) {
      this.$emit('btn-change', value)
    },
    async refresh() {
      // const tabs = await this.api()
      this.tabs = Object.freeze(this.tabs)
      console.log(this.tabs)
    },
    tabchange(value) {
      console.log(value.name)
      this.$emit('input', value.name)
    },
    handleClick(state) {
      const i = this.statusList.findIndex(value => value === state)
      if (i === -1) {
        this.$page[state] = 'Y'
        this.statusList.push(state)
      } else {
        this.$page[state] = null
        this.statusList.splice(i, 1)
      }
      const a = JSON.stringify(this.statusList)
      this.$page.zonglanList = JSON.parse(a)
      this.$emit('input', this.statusList)
    },
    addClass(name) {
      if (this.statusList.indexOf(name) === -1) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-tabs {
  display: flex;
  position: relative;
  background: #ffffff;
  justify-content: space-between;
  border-bottom: 1px solid #e4e7ed;
  // padding: 0 12px;
  ul{
    display: flex;
    margin: 0;
    padding: 0;
    list-style-type:none;
    li{
      display: flex;
      align-items: center;
      color: #333333;
      justify-content: center;
      margin: 10px;
      width: 95px;
      height: 27px;
      font-size: 12px;
      font-weight: 500;
      border-radius: 18px;
      cursor:pointer;
    }
  }
  .blue{
    background-color: #E4F3FC;
    color: #3FA9E9!important;
    border: none;
    font-weight: 600;
  }
}
/deep/.el-tabs--top{
  padding-left: 25px;
  height: 48px;
.is-top::after {
width: 0px;
}
}
</style>
